import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import CauseAndEffectCard from './CauseAndEffectCard';
import { filterUndefined } from '../../../../../utils/FilterUndefinedObject';

const defaultProps = {
  causeCard: { key: 0 },
  effectCard: { key: 0 },
  isSmallThumbnail: false,
};

export default function CauseAndEffectThumbnailComponent(p) {
  const {
    causeCard,
    effectCard,
    isSmallThumbnail,
  } = { ...defaultProps, ...filterUndefined(p) };
  return (
    <div className='cause-and-effect-thumbnail-component vizzle-cause-and-effect-card-thumbnail'>
      <div className='card-container'>
        <CauseAndEffectCard card={causeCard} isSmallThumbnail={isSmallThumbnail} />
      </div>
      <div>
        <DoubleArrowIcon className='arrow' />
      </div>
      <div className='card-container'>
        <CauseAndEffectCard card={effectCard} isSmallThumbnail={isSmallThumbnail} />
      </div>
    </div>
  );
}
